export const STEPS = {
  CREDENTIALS: 'credentials',
  CODE: 'code'
};

// Same threshold as the legacy ClaveÚnica screen before offering the manual path.
export const MAX_CREDENTIAL_ERRORS = 2;
// Service failures (scraper or ClaveÚnica unreachable) before only the manual path is left.
export const MAX_SERVICE_ERRORS = 2;
export const CODE_LENGTH = 6;
// Official ClaveÚnica portal: get or recover the password there, never here.
export const CLAVE_UNICA_PORTAL = 'https://claveunica.gob.cl/';
// kayak keeps the half-done ClaveÚnica session for 300s from the last step; a
// small margin covers the request latency.
export const CODE_WINDOW_SECONDS = 290;
const SECONDS_PER_MINUTE = 60;

export const formatTimeLeft = seconds =>
  `${Math.floor(seconds / SECONDS_PER_MINUTE)}:${String(seconds % SECONDS_PER_MINUTE).padStart(2, '0')}`;
